import { Link } from "react-router-dom";

const AppBreadcrumb = ({
  items = [],
  currentLabel,
  className = "",
  compact = false,
}) => {
  const containerSize = compact ? "px-3 py-2" : "px-3 py-2";
  const textSize = compact ? "text-[11px]" : "text-2xs md:text-xs";

  return (
    <nav
      aria-label="Breadcrumb"
      className={[
        "overflow-x-auto rounded-xl border border-blue-100",
        "bg-gradient-to-r from-white via-blue-50/70 to-teal-50/70 w-fit",
        "shadow-sm",
        containerSize,
        className,
      ].join(" ")}
    >
      <ol className={["flex items-center gap-2 whitespace-nowrap", textSize].join(" ")}>
        {items.map((item, idx) => {
          const isLastFromItems = idx === items.length - 1;

          return (
            <li key={`${item.label}-${idx}`} className="flex items-center gap-2">
              {item.to ? (
                <Link
                  to={item.to}
                  className="font-medium text-gray-600 transition-colors hover:text-blue-700"
                >
                  {item.label}
                </Link>
              ) : typeof item.onClick === "function" ? (
                <button
                  type="button"
                  onClick={item.onClick}
                  className="font-medium text-gray-600 transition-colors hover:text-blue-700 hover:underline"
                >
                  {item.label}
                </button>
              ) : (
                <span className="font-medium text-gray-600">{item.label}</span>
              )}

              {(!isLastFromItems || currentLabel) && (
                <span className="text-gray-300">/</span>
              )}
            </li>
          );
        })}

        {currentLabel && (
          <li>
            <span className="rounded-full bg-blue-100 px-2 py-0.5 font-semibold text-blue-700">
              {currentLabel}
            </span>
          </li>
        )}
      </ol>
    </nav>
  );
};

export default AppBreadcrumb;
